import React, { useRef, useState } from "react";
import style from "./index.module.scss";
import { message, Popover } from "antd";
import ExerciseModal from "../ExerciseModal";
import useModalHandler from "../../../../../utils/useModalHandler";
import { ExerciseStatus } from "../../../../../service/exercise";
import useVerifyExercise from "../../../../../utils/useVerifyExercise";
import { errorMessage } from "../../../../../service/service";

interface ListDropDownProps {
    id: number;
    updateList?: () => void;
    status: ExerciseStatus;
    onDelete: (exerciseId: number) => void;
}

export default function ListDropDown({
    id,
    updateList,
    status,
    onDelete
}: ListDropDownProps) {
    const modal = useModalHandler();
    const ref = useRef<HTMLDivElement>(null);
    const [visible, setVisible] = useState(false);
    const { onVerify } = useVerifyExercise();

    // onVerify 方法第二个参数
    const verifyStatusList = [
        {
            verifyStatus: ExerciseStatus.del,
            noticeContent: "练习活动已删除，请刷新页面"
        }
    ];

    const verifyDoneStatus = {
        verifyStatus: ExerciseStatus.done,
        noticeContent: "练习活动已结束，请刷新页面"
    };

    const popover = (
        <div className={style.popover}>
            {status !== ExerciseStatus.done && (
                <button onClick={onClick}>设置</button>
            )}
            <button onClick={onDelFn}>删除</button>
        </div>
    );

    async function onClick() {
        try {
            const executeContinue = await onVerify(id, [
                ...verifyStatusList,
                verifyDoneStatus
            ]);
            if (executeContinue) {
                setVisible(true);
                modal.open();
            }
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    function onCancel() {
        modal.close();
        setVisible(false);
    }

    function onOk() {
        updateList?.();
        onCancel();
    }

    async function onDelFn() {
        try {
            const executeContinue = await onVerify(id, verifyStatusList);
            if (executeContinue) onDelete(id);
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <div className={style.root} ref={ref}>
            <Popover
                content={popover}
                placement="bottom"
                overlayClassName={style.popoverWrapper}
                getPopupContainer={() => ref.current!}>
                <button className={style.more} />
            </Popover>

            {visible && (
                <ExerciseModal
                    type="modify"
                    visible={modal.visible}
                    onOk={onOk}
                    onCancel={onCancel}
                    id={id}
                />
            )}
        </div>
    );
}
